export const queryKeys = {
  fetchProfile: 'fetchProfile',
  fetchContentTypePermissions: 'fetchContentTypePermissions',
  chat: {
    createSession: 'chatCreateSession',
    getSessions: 'chatGetSessions',
    getDefaultQuestions: 'chatGetDefaultQuestions',
  },
  consent: {
    getConsent: 'consentGetConsent',
  },
};
